import store from '@/store'
import { PostgrestClient } from '@supabase/postgrest-js'
import useLogger from '@/composables/useLogger'
const logger = useLogger('csvtable')

// const CsvTableDatasourceClient = () => {
//   const csvTableAuth = config => {
//     return store.dispatch('getCurrentUser')
//       .then((user) => {
//         const idToken = user.tokens.idToken
//         config.headers.Authorization = `Bearer ${idToken}`
//         return Promise.resolve(config)
//       })
//   }
//   const client = axios.create({
//     baseURL: process.env.VUE_APP_CSV_TABLE_DATASOURCE_ENDPOINT
//   })
//   client.onError((axiosError) => {
//     if (axiosError.isAxiosError) {
//       const msgs = pathOr([axiosError.message], ['response', 'data', 'errors'], axiosError)
//       const statusCode = pathOr('???', ['response', 'status'], axiosError)
//       const error = new Error(msgs.join('; '))
//       error.status = statusCode
//       throw error
//     } else {
//       throw axiosError
//     }
//   })
//   client.interceptors.request.use(csvTableAuth, (error) => {
//     logger.error('Error Authenticating for CsvTableClient', error.message)
//     return Promise.reject(error)
//   })
//   return client
// }

// const csvTableDatasourceClient = CsvTableDatasourceClient()
// const hd = { 'Service-Name': 'csvtables', 'Origin': window.location.origin }
// logger.info('csvtable datasource headers', JSON.stringify(hd))
const postgrestClient = new PostgrestClient(process.env.VUE_APP_R4_ENDPOINT + '/api/v1/csvtables/')

const tableClient = async () => {
  const user = await store.dispatch('getCurrentUser')
  return postgrestClient.auth(user.tokens.IdToken)
}

/**
 * TOOD: IMPORTANT: Add Service-Name:csvtable HEADER to all requests
 *                  This is to allow the LB to route to the correct service
 */
const CsvTableDatasourceApi = {
  getTodos: async () => {
    const client = await tableClient()
    const { data, error } = await client.from('todos').select().order('id', { ascending: false })
    if (error) {
      logger.error(error.message)
      throw error
    }
    return data
  }
}

export default CsvTableDatasourceApi
